export const LOADING = "REALESTATE-LOADING";
export const OPERATIONS = "REALESTATE-OPERATIONS";